/**
 * Converts a JSON object to a map of a specified type keyed by strings
 *
 * @param object {any}
 */
export function parseJSONMap<T>(object: any): Map<string, T> {
    const map = new Map<string, T>();

    for (const key of Object.keys(object)) {
        map.set(key, object[key] as T);
    }

    return map;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/json-utils.ts